import axios from 'axios';

const KEY = 'support.impersonation';
const fragment = new URLSearchParams(window.location.hash.slice(1));
const incoming = fragment.get('impersonation');
if (incoming !== null) {
  // Remove credentials before routing, analytics initialization, or error reporting.
  window.history.replaceState(
    null,
    '',
    window.location.pathname + window.location.search,
  );
  window.sessionStorage.setItem(KEY, incoming);
}

export function getImpersonation() {
  const token = window.sessionStorage.getItem(KEY);
  if (token === null) return null;
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const claims = JSON.parse(
      decodeURIComponent(
        Array.prototype.map
          .call(
            atob(payload),
            (c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2),
          )
          .join(''),
      ),
    );
    if (!claims.user.impersonation || !Number.isFinite(claims.exp))
      throw new Error('Invalid session');
    return {
      token,
      username: claims.user.username,
      expiresAt: claims.exp * 1000,
    };
  } catch (e) {
    // Fail closed: never fall back to the normal account for a malformed session.
    return { token: '', username: '', expiresAt: 0 };
  }
}

export function endImpersonation() {
  window.sessionStorage.removeItem(KEY);
  window.location.replace(
    (window.env.PUBLIC_URL || '').replace(/\/$/, '') + '/',
  );
}

export function guardImpersonationRequest(config) {
  const session = getImpersonation();
  if (!session) return config;
  const raw = /^(https?:)?\/\//i.test(config.url || '')
    ? config.url
    : (config.baseURL || '').replace(/\/$/, '') +
      '/' +
      (config.url || '').replace(/^\//, '');
  const target = new URL(raw, window.location.origin);
  const api = new URL(window.env.API_URL, window.location.origin);
  const prefix = api.pathname.replace(/\/$/, '');
  if (
    target.origin !== api.origin ||
    (target.pathname !== prefix && !target.pathname.startsWith(prefix + '/'))
  )
    return config;
  if (session.expiresAt <= Date.now() || !session.token) {
    return Promise.reject(
      new Error(
        'La sesión de consulta venció. Volvé a iniciarla desde el backoffice.',
      ),
    );
  }
  // Impersonated sessions carry the target user's full permissions (reads and writes).
  // Cover direct Axios calls as well as Redux requests. Never use another tab's token.
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${session.token}`,
  };
  return config;
}

axios.interceptors.request.use(guardImpersonationRequest);
